/* src/views/accueil/proto/EcranAccueilProto.jsx — L'ÉCRAN ENTIER, transcrit
   de docs/handoff/accueil-complet.jsx (livré 2026-08-26). LE DESSIN, PAS LA
   LOGIQUE : chaque style, chaque classe, chaque taille vient du fichier —
   RIEN n'est retouché. Les valeurs d'exemple sont devenues des props ; les
   listes répétées sont devenues des map() du MÊME balisage ; les gestes gXxx
   sont devenus des props onXxx (la table de correspondance vit en fin du
   fichier livré). Les data-testid sont AJOUTÉS (attributs invisibles — le
   filet de gestes s'accroche dessus), jamais un style. */

import React from "react";

/* ── les icônes des quatre colonnes + les tips — les SVG du fichier ── */
const IcAttend = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 9v4" />
    <path d="M12 17h.01" />
    <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
  </svg>
);
const IcMsg = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M4 4h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8l-4 4V6a2 2 0 0 1 2-2Z" />
  </svg>
);
const IcTaches = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M9 11l3 3L22 4" />
    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
  </svg>
);
const IcLoupe = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.9"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="11" cy="11" r="7" />
    <path d="m21 21-4.3-4.3" />
  </svg>
);
const svgTriangle = (stroke, w) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke={stroke}
    strokeWidth={w}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
    <path d="M12 9v4" />
    <path d="M12 17h.01" />
  </svg>
);
const svgCheck = (stroke) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke={stroke}
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20 6 9 17l-5-5" />
  </svg>
);
const svgOeil = (stroke) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke={stroke}
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

/* Les huit variantes de tip du fichier — styles copiés tels quels. */
const TIPS = {
  incident_a_juger: {
    tip: "Un incident à juger",
    style: { background: "#b8412b" },
    svg: svgTriangle("#fff", "2.2"),
  },
  incident_regle: {
    tip: "Un incident, déjà réglé",
    style: { background: "#f1f4f7", border: "1.5px solid #dde4ea" },
    svg: svgTriangle("#c3cdd6", "2.2"),
  },
  valide: {
    tip: "Le ménage est validé par l'agent",
    style: { background: "#7fc4a3" },
    svg: svgCheck("#fff"),
  },
  pas_valide: {
    tip: "Pas encore validé par l'agent",
    style: { background: "#f1f4f7", border: "1.5px solid #dde4ea" },
    svg: svgCheck("#c3cdd6"),
  },
  ctrl_designe: {
    tip: "À contrôler — un contrôleur est désigné",
    style: { background: "#fdf4f0", border: "1.5px solid #b8412b" },
    svg: svgOeil("#b8412b"),
  },
  ctrl_personne: {
    tip: "À contrôler — personne de désigné",
    style: { background: "#fdf7ee", border: "1.5px dashed #d4a24c" },
    svg: svgOeil("#8a5f19"),
  },
  ctrl_ras: {
    tip: "Contrôlé — rien à signaler",
    style: { background: "#7fc4a3" },
    svg: svgOeil("#fff"),
  },
  ctrl_reprendre: {
    tip: "Contrôlé — des points à reprendre",
    style: { background: "#b8412b" },
    svg: svgOeil("#fff"),
  },
};

export function TipRond({ variante, onClic, testId }) {
  const v = TIPS[variante];
  if (!v) return null;
  const rond = (
    <span
      className="tip"
      data-tip={v.tip}
      data-testid={onClic ? undefined : testId}
      style={{
        width: "21px",
        height: "21px",
        borderRadius: "50%",
        ...v.style,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: "0",
      }}
    >
      {v.svg}
    </span>
  );
  if (!onClic) return rond;
  return (
    <span
      data-testid={testId}
      onClick={(e) => {
        e.stopPropagation();
        onClic();
      }}
      style={{ display: "inline-flex", cursor: "pointer" }}
    >
      {rond}
    </span>
  );
}

/* ── une ligne du détail MÉNAGES (bandeau déplié) ─────────────────── */
export function LigneMenageBandeau({
  ini,
  sansAgent,
  logement,
  sous,
  tips = [],
  onOuvrir,
  testId,
}) {
  return (
    <span
      onClick={onOuvrir}
      data-testid={testId}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "9px",
        width: "100%",
        textAlign: "left",
        background: "rgba(255,255,255,.12)",
        borderRadius: "10px",
        padding: "8px 10px",
        marginBottom: "6px",
        minHeight: "48px",
        cursor: "pointer",
      }}
    >
      <span
        style={{
          width: "28px",
          height: "28px",
          borderRadius: "7px",
          background: sansAgent ? "var(--terra)" : "#87b8e6",
          color: "#fff",
          fontSize: "12px",
          fontWeight: "600",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: "0",
        }}
      >
        {ini}
      </span>
      <span style={{ flex: "1", minWidth: "0" }}>
        <span
          style={{
            display: "block",
            fontSize: "12px",
            color: "#fff",
            fontWeight: "500",
          }}
        >
          {logement}
        </span>
        <span
          style={{
            display: "block",
            fontSize: "10.5px",
            color: "rgba(255,255,255,.72)",
            marginTop: "1px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {sous}
        </span>
      </span>
      <span
        style={{
          display: "flex",
          gap: "5px",
          flexShrink: "0",
          alignItems: "center",
        }}
      >
        {tips.map((t, i) => (
          <TipRond
            key={i}
            variante={t.variante}
            onClic={t.onClic}
            testId={t.testId}
          />
        ))}
      </span>
      <span style={{ color: "rgba(255,255,255,.5)", fontSize: "15px" }}>›</span>
    </span>
  );
}

/* ── une ligne du détail ARRIVÉES / DÉPARTS ───────────────────────── */
export function LigneMouvementBandeau({
  depart,
  logement,
  sous,
  heure,
  heureSure,
  heureSource,
  onOuvrir,
  testId,
}) {
  return (
    <span
      onClick={onOuvrir}
      data-testid={testId}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "9px",
        width: "100%",
        textAlign: "left",
        background: "rgba(255,255,255,.12)",
        borderRadius: "10px",
        padding: "8px 10px",
        marginBottom: "6px",
        minHeight: "48px",
        cursor: "pointer",
      }}
    >
      <span
        style={{
          width: "28px",
          height: "28px",
          borderRadius: "7px",
          background: depart ? "var(--terra)" : "var(--vert)",
          color: "#fff",
          fontSize: "12px",
          fontWeight: "600",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: "0",
        }}
      >
        {depart ? "↓" : "↑"}
      </span>
      <span style={{ flex: "1", minWidth: "0" }}>
        <span
          style={{
            display: "block",
            fontSize: "12px",
            color: "#fff",
            fontWeight: "500",
          }}
        >
          {logement}
        </span>
        <span
          style={{
            display: "block",
            fontSize: "10.5px",
            color: "rgba(255,255,255,.72)",
            marginTop: "1px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {sous}
        </span>
      </span>
      {heure && (
        <span
          style={{
            display: "flex",
            gap: "5px",
            flexShrink: "0",
            alignItems: "center",
          }}
        >
          {heureSure ? (
            <span
              data-testid="feuille-heure-annoncee"
              style={{
                display: "inline-flex",
                alignItems: "baseline",
                gap: "5px",
                flexShrink: "0",
                padding: "5px 9px",
                borderRadius: "9px",
                whiteSpace: "nowrap",
                background: "#fff",
                boxShadow: "0 1px 3px rgba(35,50,64,.14)",
              }}
            >
              <span
                style={{
                  fontSize: "15px",
                  fontWeight: "600",
                  color: "var(--navy-d)",
                }}
              >
                {heure}
              </span>
              <span style={{ fontSize: "9.5px", color: "var(--vert-tx)" }}>
                {heureSource}
              </span>
            </span>
          ) : (
            <span
              style={{
                display: "inline-flex",
                alignItems: "baseline",
                gap: "5px",
                flexShrink: "0",
                padding: "5px 9px",
                borderRadius: "9px",
                whiteSpace: "nowrap",
                background: "rgba(255,255,255,.16)",
                border: "1px dashed rgba(255,255,255,.45)",
              }}
            >
              <span
                style={{ fontSize: "15px", fontWeight: "600", color: "#fff" }}
              >
                {heure}
              </span>
              <span
                style={{ fontSize: "9.5px", color: "rgba(255,255,255,.7)" }}
              >
                {heureSource}
              </span>
            </span>
          )}
        </span>
      )}
      <span style={{ color: "rgba(255,255,255,.5)", fontSize: "15px" }}>›</span>
    </span>
  );
}

/* ── le bandeau : salutation + quatre nombres + le détail déplié ──── */
function ChiffreBandeau({ actif, n, libelle, onClic, testId }) {
  return (
    <button
      onClick={onClic}
      data-testid={testId}
      aria-expanded={actif}
      style={{
        textAlign: "left",
        padding: "5px 9px",
        margin: "-5px -3px",
        borderRadius: "9px",
        ...(actif ? { background: "rgba(255,255,255,.18)" } : {}),
      }}
    >
      <b
        style={{
          display: "block",
          fontSize: "22px",
          color: "#fff",
          fontWeight: "600",
          lineHeight: "1.1",
        }}
      >
        {n}
      </b>
      <s
        style={{
          display: "block",
          fontSize: "9.5px",
          color: actif ? "rgba(255,255,255,.9)" : "rgba(255,255,255,.7)",
          textDecoration: "none",
          marginTop: "1px",
        }}
      >
        {libelle} <span style={{ fontSize: "8px" }}>{actif ? "▲" : "▼"}</span>
      </s>
    </button>
  );
}

export function BandeauProto({
  dateTexte,
  salutation,
  aDecider,
  onADecider,
  chiffres = [],
  detail,
  onDetail,
  detailEnfants,
}) {
  return (
    <div className="bandeau">
      <p className="bSous">{dateTexte}</p>
      <h2 className="bTitre">{salutation}</h2>
      <div className="bNus">
        {/* « à décider » : PAS un dépli — le toucher fait DÉFILER jusqu'à la
            carte (dans le fichier livré c'est le seul <span> sans chevron). */}
        <span
          onClick={onADecider}
          data-testid="chiffre-a-decider"
          style={onADecider ? { cursor: "pointer" } : undefined}
        >
          <b
            style={{
              display: "block",
              fontSize: "22px",
              color: "#fff",
              fontWeight: "600",
              lineHeight: "1.1",
            }}
          >
            {aDecider}
          </b>
          <s
            style={{
              display: "block",
              fontSize: "9.5px",
              color: "rgba(255,255,255,.7)",
              textDecoration: "none",
              marginTop: "1px",
            }}
          >
            à décider
          </s>
        </span>
        {chiffres.map((c) => (
          <ChiffreBandeau
            key={c.cle}
            actif={detail === c.cle}
            n={c.n}
            libelle={c.libelle}
            onClic={() => onDetail(c.cle)}
            testId={`chiffre-${c.cle}`}
          />
        ))}
      </div>
      {detail && detailEnfants && (
        <div
          style={{
            position: "relative",
            marginTop: "12px",
            paddingTop: "12px",
            borderTop: "1px solid rgba(255,255,255,.18)",
          }}
        >
          {detailEnfants}
        </div>
      )}
    </div>
  );
}

/* ── les quatre colonnes de la page ───────────────────────────────── */
const COLS_TONS = {
  attend: {
    fond: "#f7ddd4",
    bord: "#d19782",
    icFond: "var(--terra)",
    titreCoul: "var(--terra-tx)",
    nFond: "var(--terra)",
    icone: <IcAttend />,
  },
  messages: {
    fond: "#d6e8f7",
    bord: "#8fb6d6",
    icFond: "var(--navy)",
    titreCoul: "var(--navy-d)",
    nFond: "var(--navy)",
    icone: <IcMsg />,
  },
  taches: {
    fond: "#faeacb",
    bord: "#cfa758",
    icFond: "var(--ambre)",
    titreCoul: "var(--ambre-tx)",
    nFond: "var(--ambre)",
    icone: <IcTaches />,
  },
  prospection: {
    fond: "#eaeff4",
    bord: "#c3cdd6",
    icFond: "#5c6773",
    titreCoul: "#3d4a57",
    nFond: null,
    icone: <IcLoupe />,
  },
};

export function ColonneProto({ ton, titre, compteur, enfants, testId }) {
  const k = COLS_TONS[ton];
  return (
    <section
      className="col"
      data-testid={testId}
      style={{ background: k.fond, borderColor: k.bord }}
    >
      <div className="colH">
        <span className="colI" style={{ background: k.icFond, color: "#fff" }}>
          {k.icone}
        </span>
        <h3 className="colT" style={{ color: k.titreCoul }}>
          {titre}
        </h3>
        {compteur !== null && compteur !== undefined && (
          <span
            className="colN"
            data-testid={testId ? `${testId}-compteur` : undefined}
            style={{ background: k.nFond, color: "#fff", border: "none" }}
          >
            {compteur}
          </span>
        )}
      </div>
      {enfants}
    </section>
  );
}

/** Une ligne de colonne — `terra` = la version soulignée du fichier. */
// ⚠️ `action` EST RENDUE HORS DU BOUTON, ET C'EST OBLIGATOIRE. La ligne EST un
// <button> ; y imbriquer un second bouton produit du HTML invalide — le
// navigateur le déplace hors du parent, et le clic part au mauvais endroit
// (ouvrir l'écran au lieu de marquer traité). Le symptôme serait plausible et
// muet : « la coche ouvre la fiche ».
export function LigneCol({
  terra,
  pc,
  pcTerra,
  pcStyle,
  titre,
  sous,
  tag,
  source,
  onClic,
  testId,
  action,
}) {
  const ligne = (
    <button
      className="ligne"
      data-testid={testId}
      onClick={onClic}
      style={
        terra
          ? { borderColor: "var(--terra-bd)", background: "var(--terra-bg)" }
          : {}
      }
    >
      <span
        className="pc"
        style={
          pcTerra
            ? { background: "var(--terra)", color: "#fff" }
            : pcStyle || {}
        }
      >
        {pc}
      </span>
      <span className="co">
        <span className="t">{titre}</span>
        <span className="s" style={terra ? { color: "var(--terra-tx)" } : {}}>
          {sous}
        </span>
      </span>
      {tag && <span className="tag t-b">{tag}</span>}
      {/* LA PROVENANCE — elle s'AFFICHE, elle n'entre jamais dans le tri
          (src/lib/accueil-urgence.js). Dimitri : « ce n'est pas parce que ça
          vient de toi que c'est plus urgent — ni l'inverse ». */}
      {source && (
        <span
          data-testid="ligne-source"
          style={{
            display: "inline-flex",
            alignItems: "center",
            height: 17,
            padding: "0 7px",
            borderRadius: 9,
            background: "#87b8e6",
            color: "#fff",
            fontSize: 9,
            fontWeight: 600,
            flexShrink: 0,
            marginRight: 4,
            whiteSpace: "nowrap",
          }}
        >
          {source}
        </span>
      )}
      <span className="ch">›</span>
    </button>
  );
  if (!action) return ligne;
  return (
    <div style={{ display: "flex", alignItems: "stretch", gap: 6 }}>
      <span style={{ flex: 1, minWidth: 0, display: "flex" }}>{ligne}</span>
      {action}
    </div>
  );
}

export function PageColonnes({ enfants }) {
  return (
    <div className="page">
      <div className="cols">{enfants}</div>
    </div>
  );
}
